import { getViduCost } from '@/app/apis';
import { VOICE_CLONE_COST_BIZ_CODE } from './constants';

export {
  materialsCreateVoice,
  materialsGetVoice,
  materialsListVoiceTasks,
  materialsUpdateVoice as updateVoice,
} from '@/app/services/vidu/sdk.gen';

export const getVoiceCloneCost = () =>
  getViduCost({
    query: {
      biz_code: VOICE_CLONE_COST_BIZ_CODE,
    },
  });
